import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { SUCCESS_NOTIFICATION, ERROR_NOTIFICATION } from 'constants/ActionTypes';
import { NotificationManager } from 'react-notifications';
import swal from 'sweetalert';

function* errorNotification({ payload }) {
	// Fehlermeldungs Notification anzeigen
	const { error, message } = payload || { error: null, message: '' };
	NotificationManager.error(JSON.stringify(message), 'Fehler', 5000, () => (error ? swal(JSON.stringify(error)) : console.log('')));
}

function* successNotification({ payload }) {
	// Erfolgsmeldung Notification anzeigen
	const { message } = payload || { message: 'Aktion erfolgreich ausgeführt' };
	NotificationManager.success(message);
}

export function* notifications() {
	yield takeEvery(SUCCESS_NOTIFICATION, successNotification);
	yield takeEvery(ERROR_NOTIFICATION, errorNotification);
}

export default function* rootSaga() {
	yield all([fork(notifications)]);
}



// WEBPACK FOOTER //
// ./sagas/Notifications.js